"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeDiffInDays = getTimeDiffInDays;
exports.getTimeDiffInHours = getTimeDiffInHours;
exports.getTimeDiffInMinutes = getTimeDiffInMinutes;
exports.getTimeDiffInSeconds = getTimeDiffInSeconds;
exports.getTimeDiff = getTimeDiff;
const constants_1 = require("@daytrip/constants");
function getTimeDiffInDays(date1, date2) {
    return getTimeDiff(date1, date2) / constants_1.DAY_IN_MILLISECONDS;
}
function getTimeDiffInHours(date1, date2) {
    return getTimeDiff(date1, date2) / constants_1.HOUR_IN_MILLISECONDS;
}
function getTimeDiffInMinutes(date1, date2) {
    return getTimeDiff(date1, date2) / constants_1.MINUTE_IN_MILLISECONDS;
}
function getTimeDiffInSeconds(date1, date2) {
    return getTimeDiff(date1, date2) / constants_1.SECOND_IN_MILLISECONDS;
}
function getTimeDiff(date1, date2) {
    const secondDateMs = date2 ? new Date(date2).getTime() : Date.now();
    return new Date(date1).getTime() - secondDateMs;
}
//# sourceMappingURL=getTimeDiff.js.map